<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="container-fluid" v-if="typeof gross_winning != 'undefined'">
            <div class="text-center my-2 mb-4">
              {{$t("Gross Winning")}}:
              <strong>{{round(gross_winning)}}</strong>
              | {{$t("Total Amount")}}:
              <strong>{{round(total_amount)}}</strong>
              | {{$t("Winning Tax")}}:
              <strong>{{round(winning_tax)}}</strong>
            </div>
          </div>
          <div class="filters-container">
            <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
            <DropdownColumns
              v-model="fields"
              class="customize"
              :export-link="exportLink"
              :export-json="exportJson"
            />
          </div>
          <div style="overflow:auto">
            <b-table
              id="dynamic-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              stacked="md"
              v-model="copy"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
              v-columns-resizable="{afterResize: columnsWidthChanged}"
            >
              <template v-slot:head(player_name)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(player_surname)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(player_cnp)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(serial)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(stake)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(win_gross_amount)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(win_net_amount)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(win_tax)="data">{{ $t(data.label) }}</template>

              <template v-slot:cell(player_name)="data">
                <span v-if="data.value">
                  <router-link :to="`/players/${data.item.eplayer_id}`">{{ data.value }}</router-link>
                </span>
              </template>
              <template v-slot:cell(player_surname)="data">
                <span v-if="data.value">
                  <router-link :to="`/players/${data.item.eplayer_id}`">{{ data.value }}</router-link>
                </span>
              </template>
              <template v-slot:cell(player_cnp)="data">
                <span v-if="data.value">
                  <router-link :to="`/players/${data.item.eplayer_id}`">{{ data.value }}</router-link>
                </span>
              </template>

              <template v-slot:cell(serial)="data">
                <span v-if="data.value">
                  <router-link :to="`/tickets/${data.item.eticket_id}`">{{ data.value }}</router-link>
                </span>
              </template>

              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>
            </b-table>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'dynamic-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";

export default {
  name: "taxedPaidTickets",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters
  },
  data: function() {
    return {
      tableName: "taxedPaidTickets",
      filterOptions: [
        {
          field: "test",
          multiple: false,
          placeholder: "Test",
          options: [
            { name: "Test Mode", value: true },
            { name: "Live Mode", value: false }
          ],
          selected: [{ name: "Live Mode", value: false }]
        },
        {
          field: "save_time",
          type: "date",
          opens: "right",
          selected: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day")
          },
          default: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day")
          },
          ranges: {
            "Last hour": [moment().subtract(1, "hour"), moment()],
            "Last 6 hours": [moment().subtract(6, "hours"), moment()],
            "Last 24 hours": [moment().subtract(24, "hours"), moment()],
            Today: [moment().startOf("day"), moment().endOf("day")],
            Yesterday: [
              moment()
                .subtract(1, "days")
                .startOf("day"),
              moment()
                .subtract(1, "days")
                .endOf("day")
            ],
            "This week": [
              moment().startOf("isoWeek"),
              moment().endOf("isoWeek")
            ],
            "Last week": [
              moment()
                .subtract(1, "week")
                .startOf("isoWeek"),
              moment()
                .subtract(1, "week")
                .endOf("isoWeek")
            ],
            "This month": [moment().startOf("month"), moment().endOf("month")],
            "Last month": [
              moment()
                .subtract(1, "month")
                .startOf("month"),
              moment()
                .subtract(1, "month")
                .endOf("month")
            ],
            "This year": [moment().startOf("year"), moment().endOf("year")],
            "Last year": [moment().subtract(1, "year"), moment()]
          }
        }
      ],
      isBusy: false,
      sortBy: "win_gross_amount",
      sortDesc: true,
      fields: [
        {
          key: "player_name",
          label: "Name",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "player_surname",
          label: "Surname",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "player_cnp",
          label: "CNP",
          sortable: true,
          ignore: true,
          class: ""
        },
        { key: "serial", sortable: false, ignore: true, class: "" },
        { key: "stake", sortable: true, ignore: true, class: "" },
        { key: "win_gross_amount", sortable: true, ignore: true, class: "" },
        { key: "win_net_amount", sortable: true, ignore: true, class: "" },
        { key: "win_tax", sortable: true, ignore: true, class: "" }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      copy: null,
      addLabel: "",

      gross_winning: 0,
      total_amount: 0,
      winning_tax: 0
    };
  },
  computed: {
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      const endpoint = this.$store.getters["taxedPaidTicket/endpoint"];

      return `${apiUrl}/${endpoint}s?export=xls&lang=${this.lang}`;
    },
    exportJson() {
      const fields = [];
      this.fields.forEach(item => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          fields.push(key);
        }
      });

      const paginationData = this.buildPagination();

      paginationData.fields = fields;

      return JSON.stringify(paginationData);
    }
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "dynamic-table");
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.type != "date" && item.selected.length) {
          exactFields.push(item.field);
          exactValues.push(item.selected);
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = item.selected.startDate;
            paginationData.dateEnd = item.selected.endDate;
          } else {
            paginationData.dateField = item.field;
            paginationData.dateStart = moment().startOf("day");
            paginationData.dateEnd = moment().endOf("day");
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }
      return paginationData;
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = this.buildPagination();

      this.$store
        .dispatch("taxedPaidTicket/fetch", paginationData)
        .then(resp => {
          this.totalRows = resp.data.total;

          if (typeof resp.data.total_win_gross_amount != "undefined") {
            this.gross_winning = resp.data.total_win_gross_amount;
            this.total_amount = resp.data.total_win_net_amount;
            this.winning_tax = resp.data.total_win_tax;
          }

          resp.data.rows.forEach((item, index) => {});
          callback(resp.data.rows);
        })
        .catch(err => {
          this.$bvToast.toast(
            this.$t(
              err.details && err.details.length ? err.details[0] : err.message
            ),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      //this.$router.push("/taxed-paid-tickets/" + item.eid);
    },
    redirect() {}
  }
};
</script>

<style lang="scss" scoped>
</style>


